<!-- Быстрое создание ремонта по ТС с главной страницы. -->
<template>
  <HomeQuickActionCard
    label="Добавить ремонт"
    description="Работы, запчасти, сервис или осмотр"
    icon-name="wrench"
    color="blue"
    :list-to="{ name: 'Repairs' }"
    list-label="Открыть ремонты"
    list-subject="ремонты"
    @click="showModal = true"
  />

  <Teleport to="body">
    <FleetRepairModal
      v-if="showModal"
      @close="showModal = false"
      @saved="showModal = false"
    />
  </Teleport>
</template>

<script>
import FleetRepairModal from "@/components/Fleet/Repair/Modal.vue";
import HomeQuickActionCard from "@/components/Home/QuickActionCard.vue";

export default {
  name: "HomeVehicleRepairAction",

  components: {
    FleetRepairModal,
    HomeQuickActionCard,
  },

  data() {
    return {
      showModal: false,
    };
  },
};
</script>
